import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    button: {
        background: theme.palette.secondary.main,
        boxShadow: "0px 2px 0px rgba(62, 93, 138, 0.2)",
        borderRadius: 4,
        border: "none",
        padding: `${theme.spacing(5)} ${theme.spacing(8)}`,
        color: theme.palette.primary.dark,
    },
    backMessage: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
    },
    disabledButton: {
        background: `${theme.palette.border.main} !important`,
        boxShadow: "0px 2px 0px rgba(62, 93, 138, 0.2)",
        borderRadius: 4,
        border: "none",
        padding: `${theme.spacing(5)} ${theme.spacing(8)}`,
        color: theme.palette.primary.main,
    },
    icon: {
        fontSize: "22px !important",
    },
}));
